import React from 'react';
import { LoadingAppView } from 'design-system/LoadingAppView';
const strings = {
    title: 'Sending order...',
    titleCancel: 'Cancelling order...',
};
const OrderSendingView = ({ cancel }) => (<LoadingAppView title={cancel ? strings.titleCancel : strings.title}/>);
export default OrderSendingView;
